import React from 'react';

import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import FormViewButton from 'components/Common/Buttons/FormViewButton';

/* eslint-disable react/prop-types */
const FormsActions = ({ permissions, settings, workflowType, openAddFormModal, openAccountWithholdingModal, openEditCustomerLegalEntitiesModal, openDeleteFormModal, openUnassignFormModal, onTakeQueueItem }) => ({
  id: 'action-column',
  Header: <span className={ workflowType === 'allforms' ? 'expand-header-offset' : '' }>View</span>,
  Cell: ({ row }) => (
    <div className="form-action-btn-group">
      { (workflowType === 'allforms' || workflowType === 'complete')
        && AccessControl.hasPermission(
          permissions,
          [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate]
        )
        && <FormViewButton
          content={ <span className="icon icon-apps" /> }
          className="btn btn-sm"
          title="Reopen"
          formId={ row.original.itemId }
          form={ row.original }
          permissions={ permissions }
        /> }
      { (workflowType !== 'allforms' && workflowType !== 'complete')
      && AccessControl.hasPermission(permissions,
        [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate,
          ActivityPerms.electronicView, ActivityPerms.electronicValidate])
          && <button
            className="btn btn-sm"
            type="button"
            title={ workflowType !== 'complete' ? 'Process item' : 'Reopen' }
            onClick={ () => onTakeQueueItem(row.original) }
          >
            <span className="icon icon-apps" />
          </button> }
      { (
        !row.original.isOnlineForm
              && AccessControl.hasPermission(
                permissions,
                [ActivityPerms.scannedUpload, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate],
                true
              )
      ) && (workflowType === 'allforms' && row.original.formType != null && row.original.formType.toString().toLowerCase().indexOf('w8imy') >= 0)
            && (row.original.hasParentForm || (row.original.hasAllocationStmt && row.original.allocationStmtType
            && row.original.allocationStmtName.toLowerCase().indexOf('pooled') === -1))
            && <button
              className="btn btn-sm "
              onClick={ () => openAddFormModal(row.original) }
              type="button"
              title="Add Layer"
            >
              <span className="icon icon-upload" />
              </button> }
      { (settings && settings.showWithholding && AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates]))
                && row.original.accountNumber && row.original.accountNumber !== 'N/A' && !row.original.hasParentForm
                && <button
                  className="btn btn-sm "
                  type="button"
                  onClick={ () => openAccountWithholdingModal(row.original) }
                  title="Show Withholding Rates"
                >
                  <span className="icon icon-calculator" />
                </button> }
      { (workflowType === 'allforms') && (settings && row.original.customerId && row.original.customerId !== ''
              && (
                (row.original.isOnlineForm
                  && AccessControl.hasPermission(
                    permissions,
                    [ActivityPerms.electronicValidate]
                  )
                ) || (
                  !row.original.isOnlineForm
                  && AccessControl.hasPermission(
                    permissions,
                    [ActivityPerms.scannedEdit, ActivityPerms.scannedValidate]
                  )
                  && row.original.formType
                  && row.original.formType.toString().toLowerCase() !== 'unknown'
                )
              )
      )
          && <button
            className="btn btn-sm "
            type="button"
            title="Edit Legal Entity"
            onClick={ () => openEditCustomerLegalEntitiesModal(row.original) }
          >
            <span className="icon icon-edit" />
            </button> }
      { (workflowType === 'allforms')
      && ((row.original.isOnlineForm && AccessControl.hasPermission(permissions,
        [
          ActivityPerms.electronicDelete
        ])
      )
      || (
        !row.original.isOnlineForm
          && AccessControl.hasPermission(
            permissions,
            [
              ActivityPerms.scannedDelete
            ]
          )
          && row.original.formType
          && row.original.formType.toLowerCase() !== 'unknown'
      )
      ) && <button
        className="btn btn-sm btn-danger"
        type="button"
        title="Delete form"
        onClick={ () => openDeleteFormModal(row.original) }
      >
        <span className="icon icon-delete" />
      </button>}
      { (workflowType === 'mywork') && (((settings && row.original.customerId && row.original.workflowStage === 5)
      || (settings && row.original.customerId && row.original.workflowStage === 7))
          && (
            row.original.formType
            && row.original.formType.toString().toLowerCase() !== 'unknown'
          )
      )
          && <button
            className="btn btn-sm "
            type="button"
            title="Unassign Form"
            onClick={ () => openUnassignFormModal(row.original) }
          >
            <span>
              <span className="icon icon-people-unassign">
                <span />
              </span>
            </span>
            </button> }
    </div>
  ),
  className: 'col-10p'
});
/* eslint-enable react/prop-types */

export default FormsActions;
